import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as urlTemplate from 'url-template';
import omit from 'lodash-es/omit';

import { environment } from '@environment';
import { widgetsApi } from '@shared/widgets/widgets.api';
import {
  AlertIdentificators,
  AlertResponse,
  AlertPayload,
  AlertId,
  AlertSearchPayload,
  AlertSearchResponse
} from '@shared/widgets/entities/alerts';

@Injectable()
export class AlertsService {

  constructor(
    private http: HttpClient
  ) { }

  public fetchAlertById(payload: AlertIdentificators): Observable<AlertResponse> {
    const headers = this.headers();
    const url = urlTemplate.parse(widgetsApi.alerts.get_alert).expand({
      id: payload.user_id,
    });
    return this.http.get<AlertResponse>(url, { headers });
  }

  public createAlert(payload: AlertPayload): Observable<AlertId> {
    const headers = this.headers();
    const omitPayload = omit(payload, ['user_id', 'flex_dates']);
    const body = this.httpBody(omitPayload);
    return this.http.post<AlertId>(widgetsApi.alerts.create_alert, body, { headers });
  }

  public deleteAlert(payload: AlertIdentificators): Observable<AlertId> {
    const headers = this.headers();
    const omitPayload = omit(payload, ['user_id', 'flex_dates']);
    const body = this.httpBody(omitPayload);
    return this.http.post<AlertId>(widgetsApi.alerts.delete_alert, body, { headers });
  }

  public saveAlertSearch(payload: AlertSearchPayload): Observable<AlertSearchResponse> {
    const headers = this.headers();
    const body = this.httpBody(payload);
    return this.http.post<AlertSearchResponse>(widgetsApi.alerts.searches.create_alert_search, body, { headers });
  }

  private httpBody(payload: AlertPayload | AlertIdentificators | AlertSearchPayload): HttpParams {
    let body = new HttpParams();
    Object.keys(payload).forEach((key) => {
      body = body.append(key, payload[key]);
    });
    return body;
  }

  private headers(): HttpHeaders {
    return new HttpHeaders({
      'x_application_id': environment.x_application_id,
      'ignoreLoadingBar': ''
    });
  }
}
